// extracted by mini-css-extract-plugin
export default {"skeleton":"CaseDescriptionItem_skeleton__Gcesz","divider":"CaseDescriptionItem_divider__Cwl7-"};